import * as amplitude from '@amplitude/analytics-browser'
import { nonceScrubbingPlugin, ownerIdEnrichmentPlugin } from '@/shared/utils/analyticsPlugins'
import { startObservability } from '@/shared/utils/observabilityConfig'

const amplitudeApiKey = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY

if (amplitudeApiKey) {
    // Both plugins are registered before init so they run ahead of the SDK's own
    // enrichment plugins, which is what lets the scrubbing reach the page view the
    // SDK emits while it initialises.
    amplitude.add(ownerIdEnrichmentPlugin())
    amplitude.add(nonceScrubbingPlugin())

    amplitude.init(amplitudeApiKey, {
        autocapture: {
            attribution: false,
            fileDownloads: false,
            formInteractions: false,
            // The SDK adds the page url to every event after our scrubbing has run,
            // so the nonce would survive on custom events. Page view events carry
            // the url themselves.
            pageUrlEnrichment: false,
            pageViews: { trackHistoryChanges: 'all' },
            sessions: false
        }
    })
}

/*
 * Next runs this after the document loads and before React hydrates, which is
 * why Faro starts here and not in a provider. A provider runs later, so it
 * misses a throw during hydration, and `reactStrictMode` renders it twice.
 *
 * No `onRouterTransitionStart` export. `getWebInstrumentations()` already
 * carries `NavigationInstrumentation`, which pushes a `faro.navigation` event
 * with the source URL, the target URL and a duration. A hook here would report
 * every clicked navigation a second time.
 *
 * It does leave a gap. That instrumentation arms on `pointerdown` or `keydown`
 * and emits only when it sees a URL change and a DOM mutation together, so a
 * programmatic `router.push` reports nothing. Adding the hook back for those
 * means de-duplicating against the SDK, which is its own piece of work.
 *
 * The try/catch is what the Next docs ask for. A failure to start telemetry
 * must not stop the app.
 */
try {
    startObservability()
} catch (error) {
    console.error('Failed to start observability:', error)
}
